import { type SwimlaneOptions } from '../businessProcess/definitions';
import { type MouseEventData } from '../external-types';
import Shape from '../objects/Shape';
import Table from '../objects/Table';
import ShapeDrawingBrush, {
  type CreateObjectOptions,
} from './ShapeDrawingBrush';

class SwimlaneDrawingBrush extends ShapeDrawingBrush<SwimlaneOptions> {
  _createObject(options: CreateObjectOptions, drawing: boolean) {
    const controller = this.canvas.controller;
    const size = drawing ? 5 : 100;

    const table = new Table({
      controller,
      ...controller.defaultsManager.for('table'),
      ...options,
      numColumns: 1,
      numRows: 1,
      width: size,
      height: size,
    });

    return controller.addToCanvas(table);
  }

  onMouseUp(eventData: MouseEventData) {
    const val = super.onMouseUp(eventData);

    const table = this.shape as Table;

    if (table) {
      if (this.initialOptions.hasDivider) {
        table.setTableDimensions([30, table.width - 30], [table.height]);
      }

      // add the label as a rotated text shape. This is (hopefully) a temporary measure until
      // we support rotated text in the table cell itself
      Shape.create({
        shapeName: 'text',
        controller: this.canvas.controller,
        top: table.top + table.height,
        left: table.left,
        width: table.height,
        angle: 270,
        height: 30,
        textContent: '<p>Double-click to edit</p>',
        textAlign: 'center',
        wrapText: true,
        fontSize: 14,
        fill: null,
      });
    }

    return val;
  }
}

export default SwimlaneDrawingBrush;
